<template>
  <b-modal
            id="modal-qrcode"
            ref="qrcode-modal"
            size="lg"
            hide-footer
            title="Using Component Methods"
          >
            <template #modal-header="{ close }">
              <button class="btn btn-modal-close" @click="close()">
                <span class="material-icons"> close </span>
              </button>
              <!-- Emulate built in modal header close button action -->
              <div class="container">
                <div class="row">
                  <div class="col-12 d-flex align-items-center">
                    <p class="h4 d-inline heading-text">
                      Autenticação de dois fatores
                    </p>
                  </div>
                  <div class="col">
                    <p class="description-modal" style="font-size:13px;">
                      Para configurar o duplo-fator de segurança (2FA) use o aplicativo de preferência
          como Google Authenticator (veja os links abaixo) e leia o QRCode abaixo para obter o código.
                    </p>
                  </div>
                </div>
              </div>
            </template>
<div class="two-factor-image">
        <div v-show="RequestingCode">
            <LoadingAnim />
        </div>
        <div class="qr-code mb-2"><img :src="imageCode" /></div>
        <p class="m-3" style="color: #707070; font-size:13px;">
          <span class="step-circle" style="padding: 0.4em 0.9em 0.4em 0.9em;">1</span>Baixe o aplicativo nos links abaixo e leia o qrcode:
        </p>
        <div class="row">
          <div class="col-12 col-md-6">
            <a
              class="btn-store"
              target="_blank"
              href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2">
              <div class="pr-2">
                <svg height="800px" width="800px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 511.999 511.999" xml:space="preserve">
                <g>
                  <path style="fill:#32BBFF;" d="M382.369,175.623C322.891,142.356,227.427,88.937,79.355,6.028
                    C69.372-0.565,57.886-1.429,47.962,1.93l254.05,254.05L382.369,175.623z"/>
                  <path style="fill:#32BBFF;" d="M47.962,1.93c-1.86,0.63-3.67,1.39-5.401,2.308C31.602,10.166,23.549,21.573,23.549,36v439.96
                    c0,14.427,8.052,25.834,19.012,31.761c1.728,0.917,3.537,1.68,5.395,2.314L302.012,255.98L47.962,1.93z"/>
                  <path style="fill:#32BBFF;" d="M302.012,255.98L47.956,510.035c9.927,3.384,21.413,2.586,31.399-4.103
                    c143.598-80.41,237.986-133.196,298.152-166.746c1.675-0.941,3.316-1.861,4.938-2.772L302.012,255.98z"/>
                </g>
                <path style="fill:#2C9FD9;" d="M23.549,255.98v219.98c0,14.427,8.052,25.834,19.012,31.761c1.728,0.917,3.537,1.68,5.395,2.314
                  L302.012,255.98H23.549z"/>
                <path style="fill:#29CC5E;" d="M79.355,6.028C67.5-1.8,53.52-1.577,42.561,4.239l255.595,255.596l84.212-84.212
                  C322.891,142.356,227.427,88.937,79.355,6.028z"/>
                <path style="fill:#D93F21;" d="M298.158,252.126L42.561,507.721c10.96,5.815,24.939,6.151,36.794-1.789
                  c143.598-80.41,237.986-133.196,298.152-166.746c1.675-0.941,3.316-1.861,4.938-2.772L298.158,252.126z"/>
                <path style="fill:#FFD500;" d="M488.45,255.98c0-12.19-6.151-24.492-18.342-31.314c0,0-22.799-12.721-92.682-51.809l-83.123,83.123
                  l83.204,83.205c69.116-38.807,92.6-51.892,92.6-51.892C482.299,280.472,488.45,268.17,488.45,255.98z"/>
                <path style="fill:#FFAA00;" d="M470.108,287.294c12.191-6.822,18.342-19.124,18.342-31.314H294.303l83.204,83.205
                  C446.624,300.379,470.108,287.294,470.108,287.294z"/>
                </svg>
              </div>
              <div class="text">
                <span>Obter no</span>
                Google Play
              </div>
            </a>
          </div>
          <div class="col-12 col-md-6">
            <a
              class="btn-store"
              target="_blank"
              href="https://apps.apple.com/br/app/google-authenticator/id388497605">
              <div class="pr-2">
                <svg fill="#ffffff" version="1.1" xmlns="http://www.w3.org/2000/svg" height="28px" viewBox="0 0 512 512">
                <path d="M248.644,123.476c-5.45-29.71,8.598-60.285,25.516-80.89
                c18.645-22.735,50.642-40.17,77.986-42.086c4.619,31.149-8.093,61.498-24.826,82.965
                C309.37,106.527,278.508,124.411,248.644,123.476z M409.034,231.131c8.461-23.606,25.223-44.845,51.227-59.175
                c-26.278-32.792-63.173-51.83-97.99-51.83c-46.065,0-65.542,21.947-97.538,21.947c-32.96,0-57.965-21.947-97.866-21.947
                c-39.127,0-80.776,23.848-107.19,64.577c-9.712,15.055-16.291,33.758-19.879,54.59c-9.956,58.439,4.916,134.557,49.279,202.144
                c21.57,32.796,50.321,69.737,87.881,70.059c33.459,0.327,42.951-21.392,88.246-21.616c45.362-0.258,53.959,21.841,87.372,21.522
                c37.571-0.317,67.906-41.199,89.476-73.991c15.359-23.532,21.167-35.418,33.11-62.023
                C414.435,352.487,389.459,285.571,409.034,231.131z" />
                </svg>
              </div>
              <div class="text">
                <span>Obter no</span>
                Apple Store
              </div>
            </a>
          </div>
        </div>
          <div class="form-group two-factor mt-4" v-if="!VerifiedCode">
          <label for="startCode">
            <template v-if="registeredCode">
              <p style="font-size: 13px;color: #707070;"><span class="step-circle">2</span>Digite o código fornecido pelo aplicativo:</p>
            </template>
            <template v-else>
              <p style="font-size: 14px;color:#707070;">Após configurar o aplicativo digite o código fornecido:</p>
            </template>
          </label>
          <div class="two-factor d-flex justify-content-between gap-3 mb-2">
            <div class="part">
              <input
                id="startCode"
                type="text"
                maxlength="1"
                v-model="code[0]"
                placeholder=" "
                autocomplete="off"
                ref="firstCodeChar"
                @paste="inputFromClipboard"
                @keyup="(e) => nextInput(0, e)"
                @focus="(e) => e.target.select()" />
            </div>
            <div class="part" v-for="(_, index) in new Array(5)" :key="index">
              <input
                type="text"
                maxlength="1"
                placeholder=" "
                autocomplete="off"
                ref="codeChars"
                v-model="code[index + 1]"
                @keyup="(e) => nextInput(index + 1, e)"
                @focus="(e) => e.target.select()" />
            </div>
          </div>
          <template v-if="!RequestingCode">
            <button
              type="button"
              class="btn btn-yup-purple btn-block"
              :class="{ 'qt-loader qt-loader-mini qt-loader-right': isSending }"
              :disabled="isSending"
              @click="checkCode()">
              Verificar
            </button>
          </template>
        </div>
      </div>
      </b-modal>
</template>

<script>
import axios from '@/plugins/axios';
import LoadingAnim from '@/components/rebranding/animLottie/Loading.vue';

export default {
  name: 'QrcodeTfaConfig',
  components: {
    LoadingAnim,
  },
  data() {
    return {
      isSending: false,
      imageCode: null,
      registeredCode: false,
      RequestingCode: true,
      VerifiedCode: false,
      code: ['', '', '', '', '', ''],
    };
  },
  created() {
    // this.getQrCode();
  },
  methods: {
    getQrCode() {
      this.RequestingCode = true;
      axios().get('2fa/qrcode').then(async (response) => {
        const resp = response.data;
        this.registeredCode = resp.registered;

        if (this.registeredCode) {
          this.$emit('configured', true);
        }

        if (!this.registeredCode) { // If qrcode is not registered generate a new one.
          await axios().post('2fa/enable').then((response) => {
            this.imageCode = response.data.qrcode;
            this.RequestingCode = false;
          });
        } else {
          this.imageCode = resp.qrcode;
          this.RequestingCode = false;
        }
      }, (error) => {
        const code = error?.response?.status;

        let message = error?.response?.data?.error ?? error?.response?.data;

        if (!message && code) message = `Erro ${code}`;

        if (!message) message = `${error}`;

        this.$toast.show({
          type: 'danger',
          title: 'Erro ao obter QRCode',
          content: `${message}`,
        });
      });
    },
    inputFromClipboard(event) {
      event.preventDefault();

      const source = event.clipboardData.getData('text/plain');

      if (source) {
        this.code = source.substring(0, 6).replace(/\D+/g, '').split('');
      }
    },
    nextInput(current, event) {
      const key = event.key;

      if (key === 'Backspace') {
        current -= 1;
      } else if (key >= 0 && key <= 9) {
        current += 1;
      } else if (key === 'Enter' && current === 5) {
        this.checkCode();
        return;
      } else {
        return;
      }

      if (current === -1) return;

      let next;

      if (current === 0) {
        next = this.$refs?.firstCodeChar;
      } else {
        next = this.$refs.codeChars?.[current - 1];
      }

      if (next) {
        next.focus();
        next.select();
      }
    },
    checkCode() {
      if (this.isSending) return;

      const otp = this.code.join('');
      const url = '2fa/verify';

      if (otp.length !== 6) {
        this.$toast.show({
          title: 'Erro',
          content: 'Código inválido',
          type: 'danger',
        });
        return;
      }

      this.isSending = true;

      axios().post(url, { otp }).then((response) => {
        localStorage.setItem('yup_chat_tfa', JSON.stringify(this.$store.state?.auth?.token));

        if (response.data?.success) {
          this.$toast.show({
            title: 'Sucesso',
            content: 'Código verificado com sucesso!',
            type: 'success',
          });
          this.$emit('verified');
          setTimeout(() => {
            this.isSending = false;
            this.VerifiedCode = true;
          }, 500);
        } else {
          this.$toast.show({
            title: 'Erro',
            content: 'Erro na configuração do TFA',
            type: 'danger',
          });
        }
      }).catch((error) => {
        this.isSending = false;

        const status = error?.response?.status;

        if (status === 403) {
          error = 'Código invalido';
        } else if (status) {
          error = error.response.data;
        } else {
          error = `${error}`;
        }

        this.$toast.show({
          title: 'Erro',
          content: error,
          type: 'danger',
        });
      });
    },
    showModal() {
      this.$refs['qrcode-modal'].show();
    },
    hideModal() {
      this.$refs['qrcode-modal'].hide();
    },
    toggleModal() {
      // We pass the ID of the button that we want to return focus to
      // when the modal has hidden
      this.getQrCode();
      this.$refs['qrcode-modal'].toggle('#toggle-qrcode-btn');
    },
  },
};
</script>

<style lang="scss" scoped>

.step-circle {
    background: #752DE6;
    border-radius: 100%;
    color: white;
    padding: 0.5em 0.8em 0.5em 0.9em;
    margin: 1em;
}
.two-factor-loader, .two-factor-image {
  max-width: 100%;
}

.two-factor-image {
  padding: 1rem;
}

.two-factor{
  max-width: 410px;
  margin: 0 auto;
}

.btn-store {
  margin-bottom: .4rem;
  border-radius: .32rem;
  background-color: #000;
  height: 52px;
  width: 100%;
  font-size: 1rem;
  font-weight: bold;
  font-family: "Lucida Grande", sans-serif;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;

  & > * {
    pointer-events: none;
  }

  & > div > svg {
    width: 28px;
  }

  .text {
    text-align: left;

    span {
      display: block;
      font-size: 65%;
      font-weight: normal;
    }
  }
}

.two-factor {
  .btn-sms {
    border: thin solid #ccc;
    padding: 4px 14px;
    font-size: .72rem;
    border-radius: 20px;
    height: auto !important;
  }

  .to-app {
    background-color: transparent;
    padding-right: 0;
    padding-left: 0;
    color: var(--clr-yup-purple);
  }

  .part {
    width: 14%;

    & > input {
      border-radius: .3rem;
      border: thin solid #ccc;
      outline: 0 solid #752DE6;
      width: 100%;
      padding: .62rem 0;
      transition: .2s all ease;
      text-align: center;

      &:not(:placeholder-shown) {
        border-color: transparent;
        outline-width: .14rem;
      }
    }
  }
}

.two-factor-loader {
  .qt-loader {
    width: 100%;
    height: 150px;

    &::before {
      border-color: #000;
      border-left-color: transparent;
      border-bottom-color: transparent;
      left: 50% !important;
      top: 50% !important;
      margin: 0 !important;
      transform: translate(-50%, -50%);
    }
  }
}

.two-factor-image {
  text-align: center;
}

h1 {
  font-weight: bold;
  margin-bottom: 30px;
  text-align: center;
}

.eye_icon {
  color: #bfc5cb;
}

.btn {
  margin: 0.5em 0;
}

.register {
  border-color: #0e1421 !important;
  color: #0e1421;
}

.checkbox {
  font-weight: 400;
  font-size: 14px;
  color: #752de6;
  margin-bottom: 10px;
}

.form-group {
  label {
    color: var(--foreground);
    font-size: 16px;
    margin-bottom: 20px;
  }
  input:-ms-input-placeholder {
    text-transform: lowercase !important;
  }
  input::-webkit-input-placeholder {
    text-transform: lowercase !important;
  }
  input::placeholder {
    text-transform: lowercase !important;
  }

  #inputPassword {
    border-right-color: transparent;
    border-right-width: 0;
  }

  .eyes_btn {
    background-color: var(--form-input);
    border: 1px solid var(--form-border);
    border-left-color: transparent;
    border-radius: 0.25rem;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}
.darkmode .rebranding .form-control {
  border-right-color: transparent !important;
}
.darkmode .form-group .eyes_btn {
  background-color: var(--form-input);
  border-color: var(--form-border);
  border-left-color: transparent;
}
#toggle-import-btn {
  display: flex;
  align-items: center;
}
.btn-wrapper {
  gap: 2rem;
  @media (max-width: 767.98px) {
    flex-wrap: wrap;
    gap: 1rem !important;
  }
}
.import-div {
  p:first-of-type {
    color: var(--foreground);
  }
  p:last-of-type {
    color: var(--gray-font-color-4);
  }
}
.card-import tr th {
  font-weight: bold;
}
.card-import {
  tbody {
    tr {
      border-bottom-color: transparent;
    }
  }
}
::v-deep #modal-qrcode {
  .modal-lg {
    max-width: 645px !important;
  }
  .custom-file-input {
    position: absolute;
    height: 100%;
    top: 0;
    z-index: 1;
    cursor: default;
  }
  .heading-text {
    font-weight: bold;
  }
  .description-modal {
    color: var(--gray-font-color-2);
  }
  .btn-modal-close {
    top: 10px;
    position: absolute;
    right: 0;
    z-index: 5;
    span {
      transition: 0.5s;
    }
    &:hover span,
    &:focus span {
      color: var(--gray-dark) !important;
    }
  }
  .modal-header {
    button {
      .material-icons {
        color: var(--gray-font-color);
      }
    }
  }
  .modal-content {
    padding: 0 !important;
  }
}
</style>
